export function isCorrectBox(xMin: number, xMax:number, yMin:number, yMax:number) {
  return xMax > xMin && yMax > yMin;
}